import { Component, OnInit , OnDestroy , ViewChild  } from '@angular/core';
import {Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog , MatDialogRef , MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ServerService } from '../../../service/server/server.service';

@Component({
  selector: 'app-sale-document-send',
  templateUrl: './sale-document-send.component.html',
  styleUrls: ['./sale-document-send.component.css']
})
export class SaleDocumentSendComponent implements OnInit , OnDestroy {
  public isOnline:any;
  public loading = false;
  public subscription:Subscription;
  public err:string;public err_validation:boolean=false;
  public err_internet_text:string;public err_internet_validation:boolean;
  public server:any;

  
  constructor(public serverService:ServerService , public router:Router , public dialogRef:MatDialogRef<SaleDocumentSendComponent>) { }//end consructor
  
  ngOnInit() {
   this.server = localStorage.getItem("server");
  }


  close(){
    this.dialogRef.close();
  }
  //**************************************************
  recieve_erorr(err_validation,loading,en_message,pe_message,type){
   this.err_validation=err_validation; 
   if(type == 1 ) this.loading=false; 
   this.err=pe_message;
  }//end 
  //*******************************************************************************
  ngOnDestroy():void{
   if(this.subscription){
    this.subscription.unsubscribe();
   }//end if
  }//end OnDestroy
}

